<template>
  <section class="social" data-item="Social">
    <div class="social-background">
      <div v-for="(row, rowIndex) in images" :key="rowIndex" class="social-background__line">
        <a
          v-for="(image, index) in row"
          :key="index"
          class="social-background__line-media"
          :href="image.href"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon :name="image.icon" />
          <img :src="image.src" :alt="image.alt" draggable="false" loading="lazy" />
        </a>
      </div>
    </div>
    <div class="social-card">
      <div class="social-card__title">{{ $t('social.title') }}</div>
      <div class="social-card__links">
        <div class="social-card__links-title">{{ $t('social.morePhotos') }}</div>
        <a
          v-for="(item, index) in social"
          :key="index"
          class="social-card__links-item"
          :href="item.link"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="item.title"
        >
          <Icon :name="item.icon" />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const images = [
    [
      { icon: "ri:instagram-line", href: "https://instagram.com/p/DAlSd5aMRMV", src: "/images/social/1.png", alt: "Social 1" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/2.png", alt: "Social 2" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/3.png", alt: "Social 3" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/4.png", alt: "Social 4" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/5.png", alt: "Social 5" }
    ],
    [
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/6.png", alt: "Social 6" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/7.png", alt: "Social 7" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/8.png", alt: "Social 8" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/9.png", alt: "Social 9" },
      { icon: "ri:instagram-line", href: "https://instagram.com", src: "/images/social/10.png", alt: "Social 10" }
    ]
  ]

  const social = [
    { link: "https://facebook.com/zimmerhotelbosphorus", icon: "ri:facebook-fill", title: "Facebook" },
    { link: "https://instagram.com/zimmerhotels", icon: "ri:instagram-line", title: "Instagram" }
  ]
</script>

<style lang="scss" scoped>
  .social {
    @apply flex flex-col w-full relative overflow-hidden p-4;
    padding-top: calc(884 / 1440 * 100%);

    &-background {
      @apply flex flex-col gap-1 absolute inset-0 w-full h-full;

      &__line {
        @apply flex flex-1 w-full gap-1 flex-nowrap overflow-hidden;

        &-media {
          @apply flex-none h-full w-auto relative select-none;
          background: #f2f0e9;

          svg {
            @apply absolute top-3 left-3 text-white;
          }
          img {
            @apply w-auto h-full object-cover pointer-events-none;
          }
        }
      }
    }
    &-card {
      @apply inline-flex flex-col items-center justify-center gap-5 w-fit h-fit absolute inset-0 m-auto px-20 py-12 rounded-1 text-center;
      background: #f1eeeb;

      &__title {
        @apply font-display text-black text-xl font-medium tracking-wider uppercase;
      }
      &__links {
        @apply flex items-center gap-2.5;

        &-title {
          color: rgba(85, 85, 85, 0.9);
          font-size: 16px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0.16px;
          margin-right: 14px;
        }
        &-item {
          display: flex;
          width: 36px;
          height: 36px;
          justify-content: center;
          align-items: center;
          border-radius: 100px;
          background: #282828;
          font-size: 20px;
          color: #ffffff;
          flex: none;
        }
      }
    }

    @include media("md") {
      padding-top: 440px;

      &-background {
        &__line {
          &-media {
            background: #f2f0e9;
            width: calc(50% - 2px);

            img {
              @apply w-full h-full object-cover pointer-events-none;
            }
          }
        }
      }
      &-card {
        @apply gap-2 px-5 py-4.5 rounded-0;

        &__title {
          @apply text-lg;
        }
        &__links {
          @apply flex-wrap justify-center items-center gap-x-1.5 gap-2.5;

          &-title {
            @apply text-sm;
            flex: 0 0 100%;
            letter-spacing: 0.16px;
            margin-right: 0;
          }
          &-item {
            width: 32px;
            height: 32px;
            font-size: 18px;
          }
        }
      }
    }
  }
</style>
